import axios from 'axios'
import store from './../store';

export default class PurchaseService {



	getPurchases() {
		return axios.get('assets/layout/data/purchases.json').then(res => res.data.data);
    }

    async listPurchases(num,token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/listpurchases/'+num,
            headers: {
                authorization: token
            }
        });

        return res.data;
    }

    async listPurchasesByStatus(num, status) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/listpurchases/' + num+'/'+status,
            headers: {
                authorization: store.state.currentUser.token
            }
        });

        return res.data;
    }

    async sumTurnoverDigital(token,end_date) {
        var start_date = addDays(end_date, -7);
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/purchases/turnover/digital/' + start_date.toISOString() + '/' + end_date.toISOString(),
            headers: {
                authorization: token
            }
        });

        return res.data;
    }

    async sumTurnoverPhysical(token,end_date) {
        var start_date = addDays(end_date, -7);
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/purchases/turnover/physical/' + start_date.toISOString() + '/' + end_date.toISOString(),
            headers: {
                authorization: token
            }
        });

        return res.data;
    }

    async listBTCPurchases(token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/listbtcpurchases',
            headers: {
                authorization: token
            }
        });

        return res.data;
    }

    

    async getVoucher(label, token){
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/purchases/voucher/?label='+label,
            headers: {
                authorization: store.state.currentUser.token
            }
        });

        return res.data;

    }

    async listPurchasesById(id,token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/listpurchasesbyid/'+id,
            headers: {
                authorization: token
            }
        });

        return res.data;
    }


    async numberOfPurchases(token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/purchases/number',
            headers: {
                authorization: token
            }
        });

       // console.log(res);
        return res.data[0].num;
    }

    async valueOfPurchases(token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/purchases/value',
            headers: {
                authorization: token
            }
        });

        // console.log(res);
        return res.data[0].num;
    }



    async dailyPurchases(token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/dailypurchases',
            headers: {
                authorization: token
            }
        });

        return res.data;
    }


    async packagesPurchases(token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/packagespurchases',
            headers: {
                authorization: token
            }
        });

        return res.data;
    }


    async addPurchase(user_id, package_id, voucher_id, token, payment_type, bank_account, wallet_address, btc_amount, transaction_hash ) { //TODO : refactor - arguments - combine with top
        console.log('addpurchase');
        try {
            const res = await axios({
                method: 'post',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/addpurchase',
                headers: {
                    authorization: token
                },
                data: {
                    user_id: user_id,
                    package_id: package_id, 
                    voucher_id : voucher_id, 
                    payment_type: payment_type, 
                    bank_account: bank_account, 
                    wallet_address: wallet_address, 
                    btc_amount : btc_amount, 
                    transaction_hash : transaction_hash

                    
                }
            })
            return res.data.id

        } catch (error) {

            console.log(error);
        }

        return 0;
    }

    async approvePurchase(purchase_id) {
        try {
            const res = await axios({
                method: 'put',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/purchases/approve',
                headers: {
                    authorization: store.state.currentUser.token
                },
                data: {
                    id: purchase_id
                }
            });
            return res.data
        } catch (error) {
            console.log('ERROR STATUS: ' + error.response.status);
            return false
        }
    }

    async denyPurchase(purchase_id) {
        try {
            const res = await axios({
                method: 'put',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/purchases/deny',
                headers: {
                    authorization: store.state.currentUser.token
                },
                data: {
                    id: purchase_id
                }
            });
            return res.data
        } catch (error) {
            console.log('ERROR STATUS: ' + error.response.status);
            return false
        }
    }

    async listMyPurchases() {
        try {
            const res = await axios({
                method: 'get',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/purchases/me',
                headers: {
                    authorization: store.state.currentUser.token
                }
            });
            return res.data
        } catch (error) {
            console.log('ERROR STATUS: ' + error.response.status);
            return false
        }
    }

    async addVoucher(label,numberOfUses,validTill,discountPct,discountAbs,upgradeRange,token) {
        try {
            const res = await axios({
                method: 'post',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/purchases/vouchers',
                headers: {
                    authorization: token
                },
                data: {
                    label: label,
                    numberOfUses: numberOfUses,
                    validTill: validTill,
                    discountPct: discountPct,
                    discountAbs: discountAbs,
                    upgradeRange: upgradeRange,

                }
            })
            return res.data.id

        } catch (error) {

            console.log(error);
            return false;
        }

       
    }

    async getVouchers() {
        try {
            const res = await axios({
                method: 'get',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/purchases/vouchers',
                headers: {
                    authorization: store.state.currentUser.token
                }
            });
            return res
        } catch (error) {
            console.log('ERROR STATUS: ' + error.response.status);
            return false
        }
    }

    async getBTCEURPrice(){
        try {
            const res = await axios({
                method: 'get',
                url: 'https://api.pro.coinbase.com/products/BTC-EUR/ticker'
            });
            return res
        } catch (error) {
            console.log('ERROR STATUS: ' + error.response.status);
        }
    }

}


function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}